import * as Redux from 'redux'
import * as ReduxObservable from 'redux-observable'
import 'rxjs/add/operator/filter'
import 'rxjs/add/operator/mapTo'
import * as Request from '../../request'
import { ApplicationState } from '../../rootReducer'
import * as CommunityConfig from '../community-config'
import * as Constants from './constants'

const onCommunityDeactivate = (
    action$: ReduxObservable.ActionsObservable<any>,
    store: Redux.Store<ApplicationState>,
  ) => action$.ofType(Request.successConstant(Constants.UPDATE_COMMUNITY))
    .map((action) => CommunityConfig.fetchCommunities())

export const epic = ReduxObservable.combineEpics(
  onCommunityDeactivate,
)



// WEBPACK FOOTER //
// ./src/pages/communities/epic.ts